import { render } from "./AIAgents.vue?vue&type=template&id=545540bc&scoped=true"
import script from "./AIAgents.vue?vue&type=script&lang=js"
export * from "./AIAgents.vue?vue&type=script&lang=js"

import "./AIAgents.vue?vue&type=style&index=0&id=545540bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545540bc"]])

export default __exports__